import React from "react";
import { MigrationPage } from "../MigrationPage";

// These interfaces are kept (rather than deleted along with the page below) because
// src/HROAS/EditModelWeightingModal.tsx and src/HROAS/SecondaryNav.tsx still statically
// import ModelConfig — deleting it would fail the build even though those files are
// unreachable at runtime now that HROAS itself renders MigrationPage instead of mounting
// them. HROAS has been migrated to tinuiti-frontend; the prod HTTPRoute now routes
// /{company}/hroas/* there (see k8s/bpm-frontend/values.prod-eks_infra_us-west-2.yaml).
export interface ModelConfig {
  id: string;
  // Toggle label rendered in SecondaryNav. May differ from appLabel for demo
  // companies (e.g., tinuititest renders rMMM as "DTC MMM" on the toggle but
  // "Online DTC" everywhere else).
  label: string;
  // App-wide display label used by Efficient Frontier and Model Results.
  appLabel: string;
  enabled: boolean;
  weight: number;
  reasoning?: string;
  infoTooltip?: string | React.ReactNode;
  lastUpdatedDate?: string;
  lastUpdatedBy?: string;
}

export interface ModelMetadata {
  runDate: string;
  mape: string;
}

const HROAS = (): JSX.Element => (
  <MigrationPage title="Holistic ROAS" pageType="Holistic ROAS" />
);

export default HROAS;
